

















































import Nav from "@/components/Nav.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import DateAndTime from "@/components/DateAndTime.vue";
import Hamburger from "@/components/Hamburger.vue";
import "animate.css/animate.css";
import "pretty-checkbox/src/pretty-checkbox.scss";
import HtmlFunctions from "@/common/HtmlFunctions";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { JobEvent } from "./models/job.model";

import { setting } from "@/common/settings";

@Component({
    components:{
                Nav,
        DateAndTime,
        Hamburger,
        PulseLoader,
    }
})
export default class App extends Vue {

    isOpen:boolean = false;
    showMenu:boolean = false;


    async created() {
        document.title = "LetsDoIt";
        //@ts-ignore
        if(this.isAuthenticated && !this.$store.getters["socket/isConnected"]){
            await this.$store.dispatch("socket/initConnection");
            // await this.$store.dispatch("socket/init", setting.HubUrl.current);
            // await this.$store.dispatch("socket/connect");
        }
    }

    @Watch("currentPinBoard")
    currentPinBoardChanged(val:number){
        this.$store.dispatch("job/removeFromJobEvent", val);
    }

    // @Watch("jobEvents")
    // jobEventsChanged(val:JobEvent[]){
    //     if(val.some(j => j.pinboardId == this.currentPinBoard)){
    //         this.$store.dispatch("job/getJobsOnPinBoard", this.currentPinBoard);
    //         this.$store.commit("job/mRemoveFromJobEvent", this.currentPinBoard)
    //     }
    // }

    get jobEvents(){
        return this.$store.state.job.jobEvents;
    }

    get currentPinBoard(){
        return this.$store.state.app.currentPinBoard;
    }

    get isAuthenticated(){
        return this.$store.getters["auth/isAuthenticated"];
    }

    get companyName(){
        return this.$store.getters["app/companyName"];
    }

    get pinBoardName(){
        return this.$store.getters["app/currentPinBoardName"];
    }

    get loading(){
        return this.$store.getters["app/loading"];
    }

    get menu(){
        return this.$store.getters["app/menu"];
    }

    toggleMenu(){
            let show = this.$store.getters["app/menu"];
            this.$store.dispatch("app/setMenu", !show);
        }
    destroyed() {}
    fullScreen() {
            HtmlFunctions.openFullScreen();
    }
    closeScreen() {
            HtmlFunctions.closeFullscreen();
    }

}
